<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		:preloader="preloader"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<app-overlay-loader v-if="preloader" />
			<form
				class="mb-0"
				:class="{ 'loading-opacity': preloader }"
				ref="form"
				:data-url="
					selectedUrl
						? `transaction/course/${inputs.id}`
						: `transaction/course`
				"
			>
				<!-- Center ID -->
				<div class="form-group row align-items-center">
					<label for="inputs_center_id" class="col-sm-3 mb-0">
						Center
					</label>
					<app-input
						id="inputs_center_id"
						class="col-sm-9"
						type="search-select"
						:list="centerIdLists"
						v-model="inputs.center_id"
						:placeholder="'Center'"
						:required="true"
					/>
				</div>

				<!-- Course -->
				<!-- <div class="form-group row align-items-center">
					<label for="inputs_course_name" class="col-sm-3 mb-0">
						Class Name
					</label>
					<app-input
						id="inputs_course_name"
						class="col-sm-9"
						type="text"
						v-model="inputs.course_name"
						:placeholder="'Class Name'"
						:required="true"
					/>
				</div> -->

				<!-- Class Type -->
				<div class="form-group row align-items-center">
					<label for="inputs_course_type_id" class="col-sm-3 mb-0">
						Class Type
					</label>
					<app-input
						id="inputs_course_type_id"
						class="col-sm-9"
						type="search-select"
						:list="courseTypeIdLists"
						v-model="inputs.course_type_id"
						:placeholder="'Class Type'"
						:required="true"
					/>
				</div>
				
				<div class="form-group row align-items-center">
					<label for="inputs_teaching_type_id" class="col-sm-3 mb-0">
						Teaching Type
					</label>
					<app-input
						id="inputs_teaching_type_id"
						class="col-sm-9"
						type="search-select"
						:list="teacherTypeIdLists"
						v-model="inputs.teaching_type_id"
						:placeholder="'Teaching Type'"
						:required="true"
					/>
				</div>

				<!-- Product -->
				<div class="form-group row align-items-center">
					<label for="inputs_product_id" class="col-sm-3 mb-0">
						Product
					</label>
					<app-input
						id="inputs_product_id"
						class="col-sm-9"
						type="search-select"
						:list="productIdLists"
						v-model="inputs.product_id"
						:placeholder="'Product'"
						:required="true"
					/>
				</div>

				<!-- SC -->
				
				<div class="form-group row align-items-center">
					<label for="inputs_teacher_id" class="col-sm-3 mb-0">
						Teacher
					</label>
					<app-input
						id="inputs_teacher_id"
						class="col-sm-9"
						type="search-select"
						:list="courseTeacherIdLists"
						v-model="inputs.teacher_id"
						:placeholder="'Teacher'"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_side_teacher_id" class="col-sm-3 mb-0">
						Side Teacher
					</label>
					<app-input
						id="inputs_side_teacher_id"
						class="col-sm-9"
						type="search-select"
						:list="courseSideTeacherIdLists"
						v-model="inputs.side_teacher_id"
						:placeholder="'Side Teacher'"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_trainer_teacher_id" class="col-sm-3 mb-0">
						Trainer Teacher
					</label>
					<app-input
						id="inputs_trainer_teacher_id"
						class="col-sm-9"
						type="search-select"
						:list="courseTrainerTeacherIdLists"
						v-model="inputs.trainer_teacher_id"
						:placeholder="'Trainer Teacher'"
						:required="true"
					/>
				</div>
				<div class="form-group row align-items-center">
					<label for="inputs_course_sc_id" class="col-sm-3 mb-0">
						SC
					</label>
					<app-input
						id="inputs_course_sc_id"
						class="col-sm-9"
						type="search-select"
						:list="courseScIdLists"
						v-model="inputs.course_sc_id"
						:placeholder="'Course SC'"
						:required="true"
					/>
				</div>

				<!-- SC Supervisor -->
				<div class="form-group row align-items-center">
					<label for="inputs_course_sc_supervisor_id" class="col-sm-3 mb-0">
						SC Supervisor
					</label>
					<app-input
						id="inputs_course_sc_supervisor_id"
						class="col-sm-9"
						type="search-select"
						:list="courseScSupervisorIdLists"
						v-model="inputs.course_sc_supervisor_id"
						:placeholder="'Course SC Supervisor'"
						:required="true"
					/>
				</div>

				<!-- Course Date Start -->
				<!-- <div class="form-group row align-items-center">
					<label for="inputs_course_date_start" class="col-sm-3 mb-0">
						Course Date Start
					</label>
					<app-input
						id="inputs_course_date_start"
						class="col-sm-9"
						type="date"
						v-model="inputs.course_date_start"
						:placeholder="'Course Date Start'"
						:required="true"
					/>
				</div> -->

				<!-- Course Date End -->
				<!-- <div class="form-group row align-items-center">
					<label for="inputs_course_date_end" class="col-sm-3 mb-0">
						Course Date End
					</label>
					<app-input
						id="inputs_course_date_end"
						class="col-sm-9"
						type="date"
						v-model="inputs.course_date_end"
						:placeholder="'Course Date End'"
						:required="true"
					/>
				</div> -->

				<!-- Course Date CLC Start -->
				<!-- <div class="form-group row align-items-center">
					<label for="inputs_course_date_clc_start" class="col-sm-3 mb-0">
						Course Date CLC Start
					</label>
					<app-input
						id="inputs_course_date_clc_start"
						class="col-sm-9"
						type="text"
						v-model="inputs.course_date_clc_start"
						:placeholder="'Course Date CLC Start'"
						:required="true"
					/>
				</div> -->

				<!-- Course Date CLC End -->
				<!-- <div class="form-group row align-items-center">
					<label for="inputs_course_date_clc_end" class="col-sm-3 mb-0">
						Course Date CLC End
					</label>
					<app-input
						id="inputs_course_date_clc_end"
						class="col-sm-9"
						type="text"
						v-model="inputs.course_date_clc_end"
						:placeholder="'Course Date CLC End'"
						:required="true"
					/>
				</div> -->

				<!-- Nomor Urut -->
				<div class="form-group row align-items-center">
					<label for="inputs_course_serial_number" class="col-sm-3 mb-0">
						Serial Number
					</label>
					<app-input
						id="inputs_course_serial_number"
						class="col-sm-9"
						type="text"
						v-model="inputs.serial_number"
						:placeholder="'Serial Number'"
						:required="true"
					/>
				</div>
				
				<!-- Day -->
				<div class="form-group row align-items-center">
					<label for="inputs_course_day" class="col-sm-3 mb-0">
						Day
					</label>
					<app-input
						id="inputs_course_day"
						class="col-sm-9"
						type="text"
						v-model="inputs.day"
						:placeholder="'Day'"
						:required="true"
					/>
				</div>
				<!-- Course Description -->
				<div class="form-group row align-items-center">
					<label for="inputs_course_description" class="col-sm-3 mb-0">
						Class Description
					</label>
					<app-input
						id="inputs_course_description"
						class="col-sm-9"
						type="textarea"
						v-model="inputs.course_description"
						:placeholder="'Class Description'"
						:required="true"
					/>
				</div>

				<!-- Notes -->
				<div class="form-group row align-items-center">
					<label for="inputs_notes" class="col-sm-3 mb-0">
						Notes
					</label>
					<app-input
						id="inputs_notes"
						class="col-sm-9"
						type="textarea"
						v-model="inputs.notes"
						:placeholder="'Notes'"
						:required="true"
					/>
				</div>

				<div class="form-group row align-items-center">
					<label for="inputs_is_active" class="col-sm-3 mb-0">
						&nbsp;
					</label>
					<div class="col-sm-8">
						<app-input
							id="inputs_is_active"
							:list-value-field="$t('is_active')"
							type="single-checkbox"
							v-model="inputs.is_active"
						/>
					</div>
				</div>
			</form>
		</template>
	</modal>
</template>

<script>
import { FormMixin } from "../../../../../core/mixins/form/FormMixin.js";
import { ModalMixin } from "../../../../Mixins/ModalMixin";

export default {
	name: "ModalForm",
	mixins: [FormMixin, ModalMixin],
	props: {
		tableId: String,
		formId: String,
		value: {
			type: Object,
			default: () => {
				return {
					id: undefined,
					course_type_name: "",
					is_active: "",
				};
			},
		},
	},
	data() {
		return {
			preloader: false,
			inputs: {
			},
            centerIdLists: [],
			courseTypeIdLists: [],
			productIdLists: [],
			teacherTypeIdLists: [],
			courseScIdLists: [],
			courseTeacherIdLists: [],
			courseSideTeacherIdLists: [],
			courseTrainerTeacherIdLists: [],
			courseScSupervisorIdLists: [],
			modalId: this.formId,
			modalTitle: this.$t("add"),
		};
	},
	created() {
		if (this.selectedUrl) {
			this.modalTitle = this.$t("edit");
			this.preloader = true;
		}

        this.fetchData();
	},
	methods: {
		async fetchData() {
			try {
				if (this.selectedUrl) {
					this.modalTitle = this.$t("edit");
					this.preloader = true;
				}

				let [centerResponse, courseTypeResponse,teachingTypeResponse, productResponse, userResponse] =
					await Promise.all([
						axios.get("/master/center?per_page=50"),
						axios.get("/master/course-type?per_page=50"),
						axios.get("/master/teaching-type?per_page=50"),
						axios.get("/master/product?is_active=true&product_category_exclude=3,2&per_page=50"),
						axios.get("/user-list?per_page=50"),
					]);

                centerResponse.data.data.map((item) => {
                    this.centerIdLists.push({
                        id: item.id,
                        value: item.name,
                    });
                });

				courseTypeResponse.data.data.map((item) => {
                    this.courseTypeIdLists.push({
                        id: item.id,
                        value: item.course_type_desc,
                    });
                });

				productResponse.data.data.map((item) => {
                    this.productIdLists.push({
                        id: item.id,
                        value: item.name,
                    });
                });

				teachingTypeResponse.data.data.map((item) => {
                    this.teacherTypeIdLists.push({
                        id: item.teaching_type_id,
                        value: item.teaching_type_desc,
                    });
                });

				userResponse.data.data.map((item) => {
                    this.courseScIdLists.push({
                        id: item.id,
                        value: item.full_name,
                    });

                    this.courseScSupervisorIdLists.push({
                        id: item.id,
                        value: item.full_name,
                    });

                    this.courseTeacherIdLists.push({
                        id: item.id,
                        value: item.full_name,
                    });

                    this.courseSideTeacherIdLists.push({
                        id: item.id,
                        value: item.full_name,
                    });
					
                    this.courseTrainerTeacherIdLists.push({
                        id: item.id,
                        value: item.full_name,
                    });
                });

			} catch (error) {
				console.error("Error fetching data:", error);
			}
		},
		submit() {
            this.inputs.is_active = this.inputs.is_active ? 1 : 0;
			this.inputs.course_date_start = this.inputs.course_date_start ? this.formattedDate(this.inputs.course_date_start) : this.formattedDate(new Date())
			this.inputs.course_date_end = this.inputs.course_date_end ? this.formattedDate(this.inputs.course_date_end) : this.formattedDate(new Date().setMonth(new Date().getMonth() + 1))
			this.inputs.course_date_clc_start = "CLCDEFAULTSTART1"
			this.inputs.course_date_clc_end = "CLCDEFAULTEND1"
			this.save(this.inputs);
		},
		afterSuccess(response) {
			this.$toastr.s(response.data.message);
			this.$hub.$emit("reload-" + this.tableId);
		},

		afterSuccessFromGetEditData(response) {
			this.inputs = response.data;
			this.preloader = false;
		},
		formattedDate(payloadDate) {
			const originalDate = payloadDate;
			const date = new Date(originalDate);

			const year = date.getFullYear();
			const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
			const day = date.getDate().toString().padStart(2, "0");

			const formattedDate = `${year}-${month}-${day}`;

			return formattedDate;
		},
	},
};
</script>
